"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _agordo = _interopRequireDefault(require("./13_group_2022_09_22/agordo"));

var _agra = _interopRequireDefault(require("./13_group_2022_09_22/agra"));

var _agrateBrianza = _interopRequireDefault(require("./13_group_2022_09_22/agrate-brianza"));

var _albugnano = _interopRequireDefault(require("./13_group_2022_09_22/albugnano"));

var _altavalle = _interopRequireDefault(require("./13_group_2022_09_22/altavalle"));

var _altopianoDellaVigolana = _interopRequireDefault(require("./13_group_2022_09_22/altopiano-della-vigolana"));

var _aquilaDArroscia = _interopRequireDefault(require("./13_group_2022_09_22/aquila-d-arroscia"));

var _arcole = _interopRequireDefault(require("./13_group_2022_09_22/arcole"));

var _arena = _interopRequireDefault(require("./13_group_2022_09_22/arena"));

var _argenta = _interopRequireDefault(require("./13_group_2022_09_22/argenta"));

var _arnasco = _interopRequireDefault(require("./13_group_2022_09_22/arnasco"));

var _artogne = _interopRequireDefault(require("./13_group_2022_09_22/artogne"));

var _ascoliPiceno = _interopRequireDefault(require("./13_group_2022_09_22/ascoli-piceno"));

var _assago = _interopRequireDefault(require("./13_group_2022_09_22/assago"));

var _asso = _interopRequireDefault(require("./13_group_2022_09_22/asso"));

var _auronzoDiCadore = _interopRequireDefault(require("./13_group_2022_09_22/auronzo-di-cadore"));

var _ballabio = _interopRequireDefault(require("./13_group_2022_09_22/ballabio"));

var _barzio = _interopRequireDefault(require("./13_group_2022_09_22/barzio"));

var _bellagio = _interopRequireDefault(require("./13_group_2022_09_22/bellagio"));

var _berbennoDiValtellina = _interopRequireDefault(require("./13_group_2022_09_22/berbenno-di-valtellina"));

var _borghettoSantoSpirito = _interopRequireDefault(require("./13_group_2022_09_22/borghetto-santo-spirito"));

var _borgoAMozzano = _interopRequireDefault(require("./13_group_2022_09_22/borgo-a-mozzano"));

var _borgoDAnaunia = _interopRequireDefault(require("./13_group_2022_09_22/borgo-d-anaunia"));

var _borgoVirgilio = _interopRequireDefault(require("./13_group_2022_09_22/borgo-virgilio"));

var _branzi = _interopRequireDefault(require("./13_group_2022_09_22/branzi"));

var _brendola = _interopRequireDefault(require("./13_group_2022_09_22/brendola"));

var _brennero = _interopRequireDefault(require("./13_group_2022_09_22/brennero"));

var _brentonico = _interopRequireDefault(require("./13_group_2022_09_22/brentonico"));

var _brissagoValtravaglia = _interopRequireDefault(require("./13_group_2022_09_22/brissago-valtravaglia"));

var _busseto = _interopRequireDefault(require("./13_group_2022_09_22/busseto"));

var _buttapietra = _interopRequireDefault(require("./13_group_2022_09_22/buttapietra"));

var _caldarola = _interopRequireDefault(require("./13_group_2022_09_22/caldarola"));

var _caldiero = _interopRequireDefault(require("./13_group_2022_09_22/caldiero"));

var _caminoAlTagliamento = _interopRequireDefault(require("./13_group_2022_09_22/camino-al-tagliamento"));

var _campodenno = _interopRequireDefault(require("./13_group_2022_09_22/campodenno"));

var _campodolcino = _interopRequireDefault(require("./13_group_2022_09_22/campodolcino"));

var _canaleDAgordo = _interopRequireDefault(require("./13_group_2022_09_22/canale-d-agordo"));

var _capraiaELimite = _interopRequireDefault(require("./13_group_2022_09_22/capraia-e-limite"));

var _carregaLigure = _interopRequireDefault(require("./13_group_2022_09_22/carrega-ligure"));

var _casargo = _interopRequireDefault(require("./13_group_2022_09_22/casargo"));

var _casier = _interopRequireDefault(require("./13_group_2022_09_22/casier"));

var _casolaInLunigiana = _interopRequireDefault(require("./13_group_2022_09_22/casola-in-lunigiana"));

var _castegnero = _interopRequireDefault(require("./13_group_2022_09_22/castegnero"));

var _castelDAzzano = _interopRequireDefault(require("./13_group_2022_09_22/castel-d-azzano"));

var _castelIvano = _interopRequireDefault(require("./13_group_2022_09_22/castel-ivano"));

var _castellero = _interopRequireDefault(require("./13_group_2022_09_22/castellero"));

var _castelloMolinaDiFiemme = _interopRequireDefault(require("./13_group_2022_09_22/castello-molina-di-fiemme"));

var _castelnuovoMagra = _interopRequireDefault(require("./13_group_2022_09_22/castelnuovo-magra"));

var _castelplanio = _interopRequireDefault(require("./13_group_2022_09_22/castelplanio"));

var _castelrotto = _interopRequireDefault(require("./13_group_2022_09_22/castelrotto"));

var _catanzaro = _interopRequireDefault(require("./13_group_2022_09_22/catanzaro"));

var _cavedine = _interopRequireDefault(require("./13_group_2022_09_22/cavedine"));

var _cervia = _interopRequireDefault(require("./13_group_2022_09_22/cervia"));

var _chiari = _interopRequireDefault(require("./13_group_2022_09_22/chiari"));

var _cibianaDiCadore = _interopRequireDefault(require("./13_group_2022_09_22/cibiana-di-cadore"));

var _civezzano = _interopRequireDefault(require("./13_group_2022_09_22/civezzano"));

var _cividaleDelFriuli = _interopRequireDefault(require("./13_group_2022_09_22/cividale-del-friuli"));

var _cles = _interopRequireDefault(require("./13_group_2022_09_22/cles"));

var _cocconato = _interopRequireDefault(require("./13_group_2022_09_22/cocconato"));

var _cocquioTrevisago = _interopRequireDefault(require("./13_group_2022_09_22/cocquio-trevisago"));

var _colleUmberto = _interopRequireDefault(require("./13_group_2022_09_22/colle-umberto"));

var _collebeato = _interopRequireDefault(require("./13_group_2022_09_22/collebeato"));

var _colliDelTronto = _interopRequireDefault(require("./13_group_2022_09_22/colli-del-tronto"));

var _colloredoDiMonteAlbano = _interopRequireDefault(require("./13_group_2022_09_22/colloredo-di-monte-albano"));

var _cornovecchio = _interopRequireDefault(require("./13_group_2022_09_22/cornovecchio"));

var _cortacciaSullaStradaDelVino = _interopRequireDefault(require("./13_group_2022_09_22/cortaccia-sulla-strada-del-vino"));

var _corteFranca = _interopRequireDefault(require("./13_group_2022_09_22/corte-franca"));

var _cortePalasio = _interopRequireDefault(require("./13_group_2022_09_22/corte-palasio"));

var _cortenoGolgi = _interopRequireDefault(require("./13_group_2022_09_22/corteno-golgi"));

var _corvaraInBadia = _interopRequireDefault(require("./13_group_2022_09_22/corvara-in-badia"));

var _costaMasnaga = _interopRequireDefault(require("./13_group_2022_09_22/costa-masnaga"));

var _cuveglio = _interopRequireDefault(require("./13_group_2022_09_22/cuveglio"));

var _dogna = _interopRequireDefault(require("./13_group_2022_09_22/dogna"));

var _dolegnaDelCollio = _interopRequireDefault(require("./13_group_2022_09_22/dolegna-del-collio"));

var _edolo = _interopRequireDefault(require("./13_group_2022_09_22/edolo"));

var _egna = _interopRequireDefault(require("./13_group_2022_09_22/egna"));

var _fabbricheDiVergemoli = _interopRequireDefault(require("./13_group_2022_09_22/fabbriche-di-vergemoli"));

var _fagnanoOlona = _interopRequireDefault(require("./13_group_2022_09_22/fagnano-olona"));

var _fano = _interopRequireDefault(require("./13_group_2022_09_22/fano"));

var _ferrara = _interopRequireDefault(require("./13_group_2022_09_22/ferrara"));

var _fieAlloSciliar = _interopRequireDefault(require("./13_group_2022_09_22/fie-allo-sciliar"));

var _finaleLigure = _interopRequireDefault(require("./13_group_2022_09_22/finale-ligure"));

var _fiorenzuolaDArda = _interopRequireDefault(require("./13_group_2022_09_22/fiorenzuola-d-arda"));

var _flaibano = _interopRequireDefault(require("./13_group_2022_09_22/flaibano"));

var _folignano = _interopRequireDefault(require("./13_group_2022_09_22/folignano"));

var _fontanelice = _interopRequireDefault(require("./13_group_2022_09_22/fontanelice"));

var _fonte = _interopRequireDefault(require("./13_group_2022_09_22/fonte"));

var _fontevivo = _interopRequireDefault(require("./13_group_2022_09_22/fontevivo"));

var _frassinellePolesine = _interopRequireDefault(require("./13_group_2022_09_22/frassinelle-polesine"));

var _frattaPolesine = _interopRequireDefault(require("./13_group_2022_09_22/fratta-polesine"));

var _gaggiano = _interopRequireDefault(require("./13_group_2022_09_22/gaggiano"));

var _galbiate = _interopRequireDefault(require("./13_group_2022_09_22/galbiate"));

var _gambellara = _interopRequireDefault(require("./13_group_2022_09_22/gambellara"));

var _gardoneRiviera = _interopRequireDefault(require("./13_group_2022_09_22/gardone-riviera"));

var _gavirate = _interopRequireDefault(require("./13_group_2022_09_22/gavirate"));

var _gorreto = _interopRequireDefault(require("./13_group_2022_09_22/gorreto"));

var _grimacco = _interopRequireDefault(require("./13_group_2022_09_22/grimacco"));

var _grisignanoDiZocco = _interopRequireDefault(require("./13_group_2022_09_22/grisignano-di-zocco"));

var _grosio = _interopRequireDefault(require("./13_group_2022_09_22/grosio"));

var _grosotto = _interopRequireDefault(require("./13_group_2022_09_22/grosotto"));

var _gussago = _interopRequireDefault(require("./13_group_2022_09_22/gussago"));

var _imer = _interopRequireDefault(require("./13_group_2022_09_22/imer"));

var _isolaDellaScala = _interopRequireDefault(require("./13_group_2022_09_22/isola-della-scala"));

var _isolaVicentina = _interopRequireDefault(require("./13_group_2022_09_22/isola-vicentina"));

var _laces = _interopRequireDefault(require("./13_group_2022_09_22/laces"));

var _lajatico = _interopRequireDefault(require("./13_group_2022_09_22/lajatico"));

var _lastebasse = _interopRequireDefault(require("./13_group_2022_09_22/lastebasse"));

var _ledro = _interopRequireDefault(require("./13_group_2022_09_22/ledro"));

var _lendinara = _interopRequireDefault(require("./13_group_2022_09_22/lendinara"));

var _lestizza = _interopRequireDefault(require("./13_group_2022_09_22/lestizza"));

var _levicoTerme = _interopRequireDefault(require("./13_group_2022_09_22/levico-terme"));

var _lignanoSabbiadoro = _interopRequireDefault(require("./13_group_2022_09_22/lignano-sabbiadoro"));

var _luson = _interopRequireDefault(require("./13_group_2022_09_22/luson"));

var _macerata = _interopRequireDefault(require("./13_group_2022_09_22/macerata"));

var _manzano = _interopRequireDefault(require("./13_group_2022_09_22/manzano"));

var _marcheno = _interopRequireDefault(require("./13_group_2022_09_22/marcheno"));

var _mercatinoConca = _interopRequireDefault(require("./13_group_2022_09_22/mercatino-conca"));

var _meretoDiTomba = _interopRequireDefault(require("./13_group_2022_09_22/mereto-di-tomba"));

var _minucciano = _interopRequireDefault(require("./13_group_2022_09_22/minucciano"));

var _moena = _interopRequireDefault(require("./13_group_2022_09_22/moena"));

var _molteno = _interopRequireDefault(require("./13_group_2022_09_22/molteno"));

var _mombaruzzo = _interopRequireDefault(require("./13_group_2022_09_22/mombaruzzo"));

var _mongardino = _interopRequireDefault(require("./13_group_2022_09_22/mongardino"));

var _monteCavallo = _interopRequireDefault(require("./13_group_2022_09_22/monte-cavallo"));

var _monteforteDAlpone = _interopRequireDefault(require("./13_group_2022_09_22/monteforte-d-alpone"));

var _montegrinoValtravaglia = _interopRequireDefault(require("./13_group_2022_09_22/montegrino-valtravaglia"));

var _montegrossoDAsti = _interopRequireDefault(require("./13_group_2022_09_22/montegrosso-d-asti"));

var _monticelloBrianza = _interopRequireDefault(require("./13_group_2022_09_22/monticello-brianza"));

var _mornago = _interopRequireDefault(require("./13_group_2022_09_22/mornago"));

var _muccia = _interopRequireDefault(require("./13_group_2022_09_22/muccia"));

var _nibionno = _interopRequireDefault(require("./13_group_2022_09_22/nibionno"));

var _novella = _interopRequireDefault(require("./13_group_2022_09_22/novella"));

var _olbia = _interopRequireDefault(require("./13_group_2022_09_22/olbia"));

var _olgiateMolgora = _interopRequireDefault(require("./13_group_2022_09_22/olgiate-molgora"));

var _osnago = _interopRequireDefault(require("./13_group_2022_09_22/osnago"));

var _palagano = _interopRequireDefault(require("./13_group_2022_09_22/palagano"));

var _palanzano = _interopRequireDefault(require("./13_group_2022_09_22/palanzano"));

var _pedavena = _interopRequireDefault(require("./13_group_2022_09_22/pedavena"));

var _perca = _interopRequireDefault(require("./13_group_2022_09_22/perca"));

var _pergineValsugana = _interopRequireDefault(require("./13_group_2022_09_22/pergine-valsugana"));

var _pessanoConBornago = _interopRequireDefault(require("./13_group_2022_09_22/pessano-con-bornago"));

var _pettorazzaGrimani = _interopRequireDefault(require("./13_group_2022_09_22/pettorazza-grimani"));

var _piazzaAlSerchio = _interopRequireDefault(require("./13_group_2022_09_22/piazza-al-serchio"));

var _piobbico = _interopRequireDefault(require("./13_group_2022_09_22/piobbico"));

var _pisogne = _interopRequireDefault(require("./13_group_2022_09_22/pisogne"));

var _pojanaMaggiore = _interopRequireDefault(require("./13_group_2022_09_22/pojana-maggiore"));

var _polinago = _interopRequireDefault(require("./13_group_2022_09_22/polinago"));

var _ponteDiLegno = _interopRequireDefault(require("./13_group_2022_09_22/ponte-di-legno"));

var _porlezza = _interopRequireDefault(require("./13_group_2022_09_22/porlezza"));

var _portoCeresio = _interopRequireDefault(require("./13_group_2022_09_22/porto-ceresio"));

var _portoTolle = _interopRequireDefault(require("./13_group_2022_09_22/porto-tolle"));

var _pratoCarnico = _interopRequireDefault(require("./13_group_2022_09_22/prato-carnico"));

var _racines = _interopRequireDefault(require("./13_group_2022_09_22/racines"));

var _ranco = _interopRequireDefault(require("./13_group_2022_09_22/ranco"));

var _recco = _interopRequireDefault(require("./13_group_2022_09_22/recco"));

var _reggioCalabria = _interopRequireDefault(require("./13_group_2022_09_22/reggio-calabria"));

var _rivignanoTeor = _interopRequireDefault(require("./13_group_2022_09_22/rivignano-teor"));

var _ronzoChienis = _interopRequireDefault(require("./13_group_2022_09_22/ronzo-chienis"));

var _rovigo = _interopRequireDefault(require("./13_group_2022_09_22/rovigo"));

var _sabbioChiese = _interopRequireDefault(require("./13_group_2022_09_22/sabbio-chiese"));

var _salara = _interopRequireDefault(require("./13_group_2022_09_22/salara"));

var _salizzole = _interopRequireDefault(require("./13_group_2022_09_22/salizzole"));

var _salsomaggioreTerme = _interopRequireDefault(require("./13_group_2022_09_22/salsomaggiore-terme"));

var _sanFermoDellaBattaglia = _interopRequireDefault(require("./13_group_2022_09_22/san-fermo-della-battaglia"));

var _sanFlorianoDelCollio = _interopRequireDefault(require("./13_group_2022_09_22/san-floriano-del-collio"));

var _sanGiovanniAlNatisone = _interopRequireDefault(require("./13_group_2022_09_22/san-giovanni-al-natisone"));

var _sanGiovanniDiFassa = _interopRequireDefault(require("./13_group_2022_09_22/san-giovanni-di-fassa"));

var _sanMartinoInBadia = _interopRequireDefault(require("./13_group_2022_09_22/san-martino-in-badia"));

var _sanMartinoInPassiria = _interopRequireDefault(require("./13_group_2022_09_22/san-martino-in-passiria"));

var _sanPierDIsonzo = _interopRequireDefault(require("./13_group_2022_09_22/san-pier-d-isonzo"));

var _sanPietroDiCadore = _interopRequireDefault(require("./13_group_2022_09_22/san-pietro-di-cadore"));

var _sanPietroDiMorubio = _interopRequireDefault(require("./13_group_2022_09_22/san-pietro-di-morubio"));

var _sanSecondoParmense = _interopRequireDefault(require("./13_group_2022_09_22/san-secondo-parmense"));

var _sanStinoDiLivenza = _interopRequireDefault(require("./13_group_2022_09_22/san-stino-di-livenza"));

var _sanZenoDiMontagna = _interopRequireDefault(require("./13_group_2022_09_22/san-zeno-di-montagna"));

var _santAngeloLodigiano = _interopRequireDefault(require("./13_group_2022_09_22/sant-angelo-lodigiano"));

var _sappada = _interopRequireDefault(require("./13_group_2022_09_22/sappada"));

var _sassuolo = _interopRequireDefault(require("./13_group_2022_09_22/sassuolo"));

var _segonzano = _interopRequireDefault(require("./13_group_2022_09_22/segonzano"));

var _serle = _interopRequireDefault(require("./13_group_2022_09_22/serle"));

var _silandro = _interopRequireDefault(require("./13_group_2022_09_22/silandro"));

var _sillanoGiuncugnano = _interopRequireDefault(require("./13_group_2022_09_22/sillano-giuncugnano"));

var _siracusa = _interopRequireDefault(require("./13_group_2022_09_22/siracusa"));

var _stienta = _interopRequireDefault(require("./13_group_2022_09_22/stienta"));

var _storo = _interopRequireDefault(require("./13_group_2022_09_22/storo"));

var _ternate = _interopRequireDefault(require("./13_group_2022_09_22/ternate"));

var _tolmezzo = _interopRequireDefault(require("./13_group_2022_09_22/tolmezzo"));

var _torreDiSantaMaria = _interopRequireDefault(require("./13_group_2022_09_22/torre-di-santa-maria"));

var _torreano = _interopRequireDefault(require("./13_group_2022_09_22/torreano"));

var _travedonaMonate = _interopRequireDefault(require("./13_group_2022_09_22/travedona-monate"));

var _treVille = _interopRequireDefault(require("./13_group_2022_09_22/tre-ville"));

var _turate = _interopRequireDefault(require("./13_group_2022_09_22/turate"));

var _uboldo = _interopRequireDefault(require("./13_group_2022_09_22/uboldo"));

var _urbisaglia = _interopRequireDefault(require("./13_group_2022_09_22/urbisaglia"));

var _valDiZoldo = _interopRequireDefault(require("./13_group_2022_09_22/val-di-zoldo"));

var _vallelaghi = _interopRequireDefault(require("./13_group_2022_09_22/vallelaghi"));

var _vedanoOlona = _interopRequireDefault(require("./13_group_2022_09_22/vedano-olona"));

var _venzone = _interopRequireDefault(require("./13_group_2022_09_22/venzone"));

var _vermiglio = _interopRequireDefault(require("./13_group_2022_09_22/vermiglio"));

var _villaBasilica = _interopRequireDefault(require("./13_group_2022_09_22/villa-basilica"));

var _villaLagarina = _interopRequireDefault(require("./13_group_2022_09_22/villa-lagarina"));

var _villanovaMarchesana = _interopRequireDefault(require("./13_group_2022_09_22/villanova-marchesana"));

var _villanuovaSulClisi = _interopRequireDefault(require("./13_group_2022_09_22/villanuova-sul-clisi"));

var _villarPellice = _interopRequireDefault(require("./13_group_2022_09_22/villar-pellice"));

var _visso = _interopRequireDefault(require("./13_group_2022_09_22/visso"));

var _zibidoSanGiacomo = _interopRequireDefault(require("./13_group_2022_09_22/zibido-san-giacomo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _agordo["default"], {}, _agra["default"], {}, _agrateBrianza["default"], {}, _albugnano["default"], {}, _altavalle["default"], {}, _altopianoDellaVigolana["default"], {}, _aquilaDArroscia["default"], {}, _arcole["default"], {}, _arena["default"], {}, _argenta["default"], {}, _arnasco["default"], {}, _artogne["default"], {}, _ascoliPiceno["default"], {}, _assago["default"], {}, _asso["default"], {}, _auronzoDiCadore["default"], {}, _ballabio["default"], {}, _barzio["default"], {}, _bellagio["default"], {}, _berbennoDiValtellina["default"], {}, _borghettoSantoSpirito["default"], {}, _borgoAMozzano["default"], {}, _borgoDAnaunia["default"], {}, _borgoVirgilio["default"], {}, _branzi["default"], {}, _brendola["default"], {}, _brennero["default"], {}, _brentonico["default"], {}, _brissagoValtravaglia["default"], {}, _busseto["default"], {}, _buttapietra["default"], {}, _caldarola["default"], {}, _caldiero["default"], {}, _caminoAlTagliamento["default"], {}, _campodenno["default"], {}, _campodolcino["default"], {}, _canaleDAgordo["default"], {}, _capraiaELimite["default"], {}, _carregaLigure["default"], {}, _casargo["default"], {}, _casier["default"], {}, _casolaInLunigiana["default"], {}, _castegnero["default"], {}, _castelDAzzano["default"], {}, _castelIvano["default"], {}, _castellero["default"], {}, _castelloMolinaDiFiemme["default"], {}, _castelnuovoMagra["default"], {}, _castelplanio["default"], {}, _castelrotto["default"], {}, _catanzaro["default"], {}, _cavedine["default"], {}, _cervia["default"], {}, _chiari["default"], {}, _cibianaDiCadore["default"], {}, _civezzano["default"], {}, _cividaleDelFriuli["default"], {}, _cles["default"], {}, _cocconato["default"], {}, _cocquioTrevisago["default"], {}, _colleUmberto["default"], {}, _collebeato["default"], {}, _colliDelTronto["default"], {}, _colloredoDiMonteAlbano["default"], {}, _cornovecchio["default"], {}, _cortacciaSullaStradaDelVino["default"], {}, _corteFranca["default"], {}, _cortePalasio["default"], {}, _cortenoGolgi["default"], {}, _corvaraInBadia["default"], {}, _costaMasnaga["default"], {}, _cuveglio["default"], {}, _dogna["default"], {}, _dolegnaDelCollio["default"], {}, _edolo["default"], {}, _egna["default"], {}, _fabbricheDiVergemoli["default"], {}, _fagnanoOlona["default"], {}, _fano["default"], {}, _ferrara["default"], {}, _fieAlloSciliar["default"], {}, _finaleLigure["default"], {}, _fiorenzuolaDArda["default"], {}, _flaibano["default"], {}, _folignano["default"], {}, _fontanelice["default"], {}, _fonte["default"], {}, _fontevivo["default"], {}, _frassinellePolesine["default"], {}, _frattaPolesine["default"], {}, _gaggiano["default"], {}, _galbiate["default"], {}, _gambellara["default"], {}, _gardoneRiviera["default"], {}, _gavirate["default"], {}, _gorreto["default"], {}, _grimacco["default"], {}, _grisignanoDiZocco["default"], {}, _grosio["default"], {}, _grosotto["default"], {}, _gussago["default"], {}, _imer["default"], {}, _isolaDellaScala["default"], {}, _isolaVicentina["default"], {}, _laces["default"], {}, _lajatico["default"], {}, _lastebasse["default"], {}, _ledro["default"], {}, _lendinara["default"], {}, _lestizza["default"], {}, _levicoTerme["default"], {}, _lignanoSabbiadoro["default"], {}, _luson["default"], {}, _macerata["default"], {}, _manzano["default"], {}, _marcheno["default"], {}, _mercatinoConca["default"], {}, _meretoDiTomba["default"], {}, _minucciano["default"], {}, _moena["default"], {}, _molteno["default"], {}, _mombaruzzo["default"], {}, _mongardino["default"], {}, _monteCavallo["default"], {}, _monteforteDAlpone["default"], {}, _montegrinoValtravaglia["default"], {}, _montegrossoDAsti["default"], {}, _monticelloBrianza["default"], {}, _mornago["default"], {}, _muccia["default"], {}, _nibionno["default"], {}, _novella["default"], {}, _olbia["default"], {}, _olgiateMolgora["default"], {}, _osnago["default"], {}, _palagano["default"], {}, _palanzano["default"], {}, _pedavena["default"], {}, _perca["default"], {}, _pergineValsugana["default"], {}, _pessanoConBornago["default"], {}, _pettorazzaGrimani["default"], {}, _piazzaAlSerchio["default"], {}, _piobbico["default"], {}, _pisogne["default"], {}, _pojanaMaggiore["default"], {}, _polinago["default"], {}, _ponteDiLegno["default"], {}, _porlezza["default"], {}, _portoCeresio["default"], {}, _portoTolle["default"], {}, _pratoCarnico["default"], {}, _racines["default"], {}, _ranco["default"], {}, _recco["default"], {}, _reggioCalabria["default"], {}, _rivignanoTeor["default"], {}, _ronzoChienis["default"], {}, _rovigo["default"], {}, _sabbioChiese["default"], {}, _salara["default"], {}, _salizzole["default"], {}, _salsomaggioreTerme["default"], {}, _sanFermoDellaBattaglia["default"], {}, _sanFlorianoDelCollio["default"], {}, _sanGiovanniAlNatisone["default"], {}, _sanGiovanniDiFassa["default"], {}, _sanMartinoInBadia["default"], {}, _sanMartinoInPassiria["default"], {}, _sanPierDIsonzo["default"], {}, _sanPietroDiCadore["default"], {}, _sanPietroDiMorubio["default"], {}, _sanSecondoParmense["default"], {}, _sanStinoDiLivenza["default"], {}, _sanZenoDiMontagna["default"], {}, _santAngeloLodigiano["default"], {}, _sappada["default"], {}, _sassuolo["default"], {}, _segonzano["default"], {}, _serle["default"], {}, _silandro["default"], {}, _sillanoGiuncugnano["default"], {}, _siracusa["default"], {}, _stienta["default"], {}, _storo["default"], {}, _ternate["default"], {}, _tolmezzo["default"], {}, _torreDiSantaMaria["default"], {}, _torreano["default"], {}, _travedonaMonate["default"], {}, _treVille["default"], {}, _turate["default"], {}, _uboldo["default"], {}, _urbisaglia["default"], {}, _valDiZoldo["default"], {}, _vallelaghi["default"], {}, _vedanoOlona["default"], {}, _venzone["default"], {}, _vermiglio["default"], {}, _villaBasilica["default"], {}, _villaLagarina["default"], {}, _villanovaMarchesana["default"], {}, _villanuovaSulClisi["default"], {}, _villarPellice["default"], {}, _visso["default"], {}, _zibidoSanGiacomo["default"]);

exports["default"] = _default;